module.exports = __webpack_public_path__ + "static/constellations-4eee0ff82aba4d347fc46bb276834140.jpg";